const key = "5262f097";

export default key;
